import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { NilByMouthAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-nil-by-mouth-slot',
    templateUrl: './nil-by-mouth-slot.component.html',
    styleUrl: './nil-by-mouth-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NilByMouthSlotComponent implements SheetSlotComponentBase {

	@Input() action!: NilByMouthAction;
	value = null;

	constructor() {
	}
}